var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_108",
    "data-name": "Rect\\xE1ngulo 108",
    width: 18.957,
    height: 19.065,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_658",
    "data-name": "Grupo 658",
    transform: "translate(-578 -571.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_21",
    "data-name": "Elipse 21",
    transform: "translate(578 571.852)",
    fill: "#f05372",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_657",
    "data-name": "Grupo 657",
    transform: "translate(585.254 579.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_619",
    "data-name": "Grupo 619",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3352",
    "data-name": "Trazado 3352",
    d: "M.625,19.065a.612.612,0,0,1-.44-.177A.535.535,0,0,1,0,18.494a.491.491,0,0,1,.028-.163.656.656,0,0,1,.085-.163L6.3,9.342.568.9A.7.7,0,0,1,.483.572.558.558,0,0,1,.653.177.567.567,0,0,1,1.079,0H5.193a.944.944,0,0,1,.653.2,2.256,2.256,0,0,1,.341.368L9.564,5.5,13,.572A2.21,2.21,0,0,1,13.338.2a.944.944,0,0,1,.653-.2h3.916a.582.582,0,0,1,.411.177A.538.538,0,0,1,18.5.572.5.5,0,0,1,18.389.9L12.629,9.315l6.244,8.852a.415.415,0,0,1,.071.163.957.957,0,0,1,.014.163.556.556,0,0,1-.17.395.566.566,0,0,1-.426.177H14.133a1,1,0,0,1-.667-.2,1.651,1.651,0,0,1-.326-.34L9.393,13.291,5.676,18.521a1.781,1.781,0,0,1-.312.34.945.945,0,0,1-.653.2Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconX);
export default __webpack_public_path__ + "static/media/icon-x.2e977b5c5a9384ccaea4c01d4d9f111e.svg";
export { ForwardRef as ReactComponent };